
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLogoOicl as ObiLogoOiclElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-logo-oicl.js';
 
 
 

 
 export const ObiLogoOicl = createComponent({
   react: React,
   tagName: 'obi-logo-oicl',
   elementClass: ObiLogoOiclElement,
   events: {
     
   }
  });
 
 